__turbopack_context__.v({
  "bow": "LandingChrome-module__bzFFGa__bow",
  "btn": "LandingChrome-module__bzFFGa__btn",
  "btn-ghost": "LandingChrome-module__bzFFGa__btn-ghost",
  "btn-ink": "LandingChrome-module__bzFFGa__btn-ink",
  "btn-nav": "LandingChrome-module__bzFFGa__btn-nav",
  "dd-all": "LandingChrome-module__bzFFGa__dd-all",
  "dd-dismissed": "LandingChrome-module__bzFFGa__dd-dismissed",
  "dd-grid": "LandingChrome-module__bzFFGa__dd-grid",
  "dd-k": "LandingChrome-module__bzFFGa__dd-k",
  "dd-panel": "LandingChrome-module__bzFFGa__dd-panel",
  "footer": "LandingChrome-module__bzFFGa__footer",
  "frost": "LandingChrome-module__bzFFGa__frost",
  "ft-brand": "LandingChrome-module__bzFFGa__ft-brand",
  "ft-col": "LandingChrome-module__bzFFGa__ft-col",
  "ft-cols": "LandingChrome-module__bzFFGa__ft-cols",
  "ft-grass": "LandingChrome-module__bzFFGa__ft-grass",
  "ft-made": "LandingChrome-module__bzFFGa__ft-made",
  "ft-mark": "LandingChrome-module__bzFFGa__ft-mark",
  "ft-sky": "LandingChrome-module__bzFFGa__ft-sky",
  "ft-top": "LandingChrome-module__bzFFGa__ft-top",
  "ft-word": "LandingChrome-module__bzFFGa__ft-word",
  "m-only": "LandingChrome-module__bzFFGa__m-only",
  "mark": "LandingChrome-module__bzFFGa__mark",
  "menu-open": "LandingChrome-module__bzFFGa__menu-open",
  "nav": "LandingChrome-module__bzFFGa__nav",
  "nav-book": "LandingChrome-module__bzFFGa__nav-book",
  "nav-burger": "LandingChrome-module__bzFFGa__nav-burger",
  "nav-dd": "LandingChrome-module__bzFFGa__nav-dd",
  "nav-end": "LandingChrome-module__bzFFGa__nav-end",
  "nav-links": "LandingChrome-module__bzFFGa__nav-links",
  "wm-text": "LandingChrome-module__bzFFGa__wm-text",
  "wordmark": "LandingChrome-module__bzFFGa__wordmark",
});
